// extracted by mini-css-extract-plugin
export var scrollArea = "_r7-0";